import { useQuery } from "@tanstack/react-query"
import type { FormEvent } from "react"
import { fetchCompetencias } from "../api"
import { FOCO } from "./foco"

interface Props {
    selecionada: string
    onEscolher: (referencia: string) => void
}

// Quem troca de mês é o Ver, não o select: no Windows cada seta já dispara change, e o leitor de
// tela passaria por todos os meses.
export const SeletorCompetencia = ({ selecionada, onEscolher }: Props) => {
    const { data } = useQuery({ queryKey: ["competencias"], queryFn: fetchCompetencias })

    if (!data?.some((competencia) => competencia.referencia !== selecionada)) return null

    const ver = (evento: FormEvent<HTMLFormElement>) => {
        evento.preventDefault()
        const referencia = String(new FormData(evento.currentTarget).get("competencia"))
        if (referencia !== selecionada) onEscolher(referencia)
    }

    return (
        <form onSubmit={ver} className="mb-4 flex items-center justify-end gap-2 text-sm">
            <label htmlFor="competencia" className="text-soft">
                Competência
            </label>
            <select
                key={selecionada}
                id="competencia"
                name="competencia"
                defaultValue={selecionada}
                className={`min-h-11 rounded-full border border-line bg-card px-3 py-1.5 text-ink ${FOCO}`}
            >
                {data.map((competencia) => (
                    <option key={competencia.referencia} value={competencia.referencia}>
                        {competencia.rotulo}
                    </option>
                ))}
            </select>
            <button
                type="submit"
                className={`min-h-11 rounded-full border border-line bg-card px-4 py-1.5 font-semibold text-ink hover:bg-sunk ${FOCO}`}
            >
                Ver
            </button>
        </form>
    )
}
